<div class="calendar-settings-container">
  <h3>Calendar - {{ calendar.summary }}</h3>

  <div class="settings-form">
    <mat-form-field appearance="outline" class="full-width">
      <mat-label>Summary</mat-label>
      <input matInput placeholder="Summary" [(ngModel)]="calendar.summary" name="summary">
    </mat-form-field>

    <div class="checkbox-group">
      <mat-checkbox color="primary" [(ngModel)]="calendar.showInDashboard">
        Show in Dashboard
      </mat-checkbox>
    </div>

    <div class="checkbox-group">
      <mat-checkbox color="primary" [(ngModel)]="calendar.showInNotes">
        Show in Notes
      </mat-checkbox>
    </div>

    <div>
      <app-color-picker [selectedColor]="calendar.color" (colorChange)="onColorSelect($event)">
      </app-color-picker>
    </div>

  </div>

  <div class="actions">
    <button mat-raised-button color="primary" type="button" (click)="save()">Save</button>
  </div>
</div>